module.exports = __webpack_public_path__ + "img/9-Jungle-min.0fedcfef.png";